module.exports = __webpack_public_path__ + "img/category-casino.8f5446ff.png";